import React, { useCallback, useEffect } from "react";
import { Card, CardContent, Grid, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { IMaterialAudit, IMaterialAuditProps, IMaterialAuditResult } from "../../interfaces";
import { FormSectionHeader } from "../Shared/FormSectionHeader";
import { MaterialAuditTableRow } from "./MaterialAuditTableRow";
import { useMaterialAuditGroup } from "./useMaterialAuditGroup";

export const MaterialAuditGroupForm: React.FC<IMaterialAuditProps> = ({
    materialAudit,
    materialStates,
    updateMaterialAudit,
    reloadMaterial,
    readonly,
    loading
}) => {
    const { modelArray, handleSort, onUpdateMaterialAuditResult } = useMaterialAuditGroup(materialAudit?.materialAuditResults, readonly);

    const handleUpdate = useCallback(
        (updatedMaterialAuditResult: IMaterialAuditResult, removeResult = false) => {

            const updatedResults = onUpdateMaterialAuditResult(updatedMaterialAuditResult, removeResult);

            updateMaterialAudit({
                ...materialAudit,
                materialAuditResults: updatedResults,
            } as IMaterialAudit);
        },
        [materialAudit, onUpdateMaterialAuditResult, updateMaterialAudit]
    );

    const onRemoveMaterialAuditResult = useCallback(
        (materialAuditResult: IMaterialAuditResult) => {
            handleUpdate(materialAuditResult, true);
        },
        [handleUpdate]
    );

    const onUpdateResult = useCallback(
        (materialAuditResult: IMaterialAuditResult) => {
            handleUpdate(materialAuditResult);
        },
        [handleUpdate]
    );

    return (
        <>
            {modelArray.map((model, i) => (
                <Card sx={{ my: 3 }} key={(model && model[0].material.site?.value) ?? `Site Unknown ${i}`}>
                    <FormSectionHeader label={(model && model[0].material.site?.value) ?? "Site Unknown"} saving={loading} />
                    <CardContent>
                        <Grid container>
                            <TableContainer>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>Vehicle Class</TableCell>
                                            <TableCell>Location</TableCell>
                                            <TableCell>Part Identification</TableCell>
                                            <TableCell>Description</TableCell>
                                            <TableCell>Qty</TableCell>
                                            <TableCell>Status</TableCell>
                                            <TableCell>Rationale</TableCell>
                                            <TableCell>Retention Decision</TableCell>
                                            <TableCell>Audit Comments</TableCell>
                                            <TableCell />
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {model &&
                                            model.map((mar) => (
                                                <MaterialAuditTableRow
                                                    key={mar.material?.materialId}
                                                    materialAuditResult={mar}
                                                    materialStates={materialStates}
                                                    onRemove={() => onRemoveMaterialAuditResult(mar)}
                                                    onUpdate={onUpdateResult}
                                                    onReloadMaterial={reloadMaterial}
                                                    readonly={readonly}
                                                />
                                            ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Grid>
                    </CardContent>
                </Card>
            ))}
        </>
    );
};
